<template>
  <div class="select-value-field-group">
    <div v-for="(valItem, index) in newValue" :key="index + '_' + valItem.id" class="select-value-field-group__row">
      <div class="select-value-field-group__row__col">
        <m4-form-field
          type="select"
          :options="options"
          :name="'select__' + name + '[]'"
          :placeholder="placeholderSelect"
          :value="valItem.selectValue"
          @update:modelValue="(val) => onInput('selectValue', index, val)"
        ></m4-form-field>
      </div>
      <div class="select-value-field-group__row__col">
        <m4-form-field
          :name="'input__' + name + '[]'"
          :placeholder="placeholderInput"
          :value="valItem.inputValue"
          @update:modelValue="(val) => onInput('inputValue', index, val)"
        ></m4-form-field>
        <a class="select-value-field-group__row__col__remove" @click="removeItem(index)">
          <m4-icon icon="close"></m4-icon>
        </a>
      </div>
    </div>
    <m4-button
      tag="a"
      size="sm"
      variant="primary"
      left-icon="plus"
      @click="addNewRow"
      :class="(newValue.length === 0 ? ' add-btn__no-items' : '')"
    >
      {{ placeholderAddBtn }}
    </m4-button>
  </div>
</template>

<script>
export default {
  name: "M4SelectValueFieldGroup",
  data() {
    let defaultValue = this.modelValue && this.modelValue.length > 0 ? this.modelValue : this.value ? this.value : [];

    let newValue = defaultValue.map((item, index) => {
      return Object.assign({}, item, {
        id: index + 1
      });
    });

    if (newValue.length === 0 && this.showFirstOnInit) {
      newValue.push({
        id: 1,
        selectValue: "",
        inputValue: ""
      });
    }

    return {
      newValue: newValue,
      nextNextId: newValue.length + 1
    };
  },
  props: {
    name: String,
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    placeholderAddBtn: {
      type: String,
      default() {
        return "Add new row";
      }
    },
    placeholderSelect: {
      type: String,
      default() {
        return "Select";
      }
    },
    placeholderInput: {
      type: String,
      default() {
        return "Value";
      }
    },
    showFirstOnInit: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  methods: {
    addNewRow(e) {
      this.newValue.push({
        id: this.nextNextId++,
        selectValue: "",
        inputValue: ""
      });
      e.stopPropagation();
      return false;
    },
    removeItem(index) {
      if (index > -1 && this.newValue.length > 0) {
        this.newValue.splice(index, 1);
      }
    },
    onInput(attr, index, val) {
      this.newValue[index][attr] = val;
    }
  }
};
</script>
